import { useEffect, useRef, useState } from "react";
import { TailwindWrapper } from '@utils/TailwindWrapper';

import { Loader, Text, Button } from '@ui-component-library';

const HubSpotMeeting = ({ meetingUrl, className, setLoading}) => {
  const containerRef = useRef(null);
  const setLoadingFalse = () => {setLoading(false)}

  useEffect(() => {
    // Optional: dynamically create iframe to avoid SSR hydration issues
    if (containerRef.current) {
      setLoading(true);
      const iframe = document.createElement("iframe");
      iframe.src = meetingUrl;
      iframe.width = "100%";
      iframe.height = "100%";
      iframe.style.border = "none";
      iframe.title = "HubSpot Meeting Scheduler";
      iframe.addEventListener("load", setLoadingFalse);
      containerRef.current.innerHTML = ""; // Clear previous
      containerRef.current.appendChild(iframe);

      return () => {
        iframe.removeEventListener("load", setLoadingFalse);
      };
    }
  }, [meetingUrl]);

  return <div ref={containerRef} className={className} />;
};




const HSBoookAdvising = () => {
    const [loading, setLoading] = useState(true);

    const [time, setTime] = useState(10);

    const countdown = (time) => {
      setTimeout(() => {
        const nt = time-1;
        if(nt <= 0){
          setTime(0)
        } else{
          setTime(nt)
          countdown(nt)
        }
      }, 1000)
    }

    useEffect(() => {
      countdown(time);
    }, [])
    

    return (
    <TailwindWrapper>
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-cloud-50">
          <div>
            <div className="flex justify-center mb-3">
            <Loader size="xlarge" />
            <Text className="text-charcoal-500 text-center">Laddar...</Text>
            </div>
            <Button disabled={time!==0} onClick={() => {window.open("https://meetings-eu1.hubspot.com/joel-braatner/radgivningsmote-for-pluskunder", '_blank');}}>Om sidan inte laddar, klicka här {time ? "(" + time.toString() + "s)" : null}</Button>
          </div>
        </div>
      )}
      <HubSpotMeeting meetingUrl="https://meetings-eu1.hubspot.com/joel-braatner/radgivningsmote-for-pluskunder?embed=true" setLoading={setLoading} className="w-full h-full" />
    </TailwindWrapper>
    )
}

export default HSBoookAdvising;